import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import ButtonSection from '../ProjectCreate/ButtonSection';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';

const CreateNewCouponForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    coupanCode: '',
    expiryDate: '',
    discountAmount: 0,
  });

   useEffect(() => {
      const now = new Date();
      setFormData(f => ({ ...f, expiryDate: now.toISOString().slice(0, 16) }));
    }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const payload = {
      coupanId: 0,
      coupanCode: formData.coupanCode,
      discountAmount: formData.discountAmount,
      expiryDate: formData.expiryDate,
      isActive: true,
    };

    if (!payload || !formData.coupanCode || !formData.discountAmount || !formData.expiryDate) {
              Swal.fire("Error!", "Please fill all fields before saving.", "error");
              return;
            }
            if (isNaN(Number(formData.discountAmount)) || Number(formData.discountAmount) <= 0) {
              Swal.fire("Error!", "Please enter a valid discount amount.", "error");
              return;
            }
            if (new Date(formData.expiryDate) < new Date()) {
              Swal.fire("Error!", "Expiry date cannot be in the past.", "error");
              return;
            }

    try { 
        const response = await api.post('/api/Coupan/AddCoupan', payload, {
              headers: {
                'Content-Type': 'application/json',
              }
            });
        
            if (response.status === 200 || response.status === 201) {
        
              Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Coupon Created successfully.',
              }).then(() => {
                navigate(`${process.env.PUBLIC_URL}/coupon/coupon_list`);
              });
            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Unexpected Response',
                text: 'Please try again later.',
              });
            }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="theme-form">
      <Row>
        <Col sm="4">
          <FormGroup>
            <Label>Coupon Code</Label>
            <input
              name="coupanCode"
              type="text"
              className="form-control"
              placeholder="Enter coupon code here..."
              value={formData.coupanCode}
              onChange={handleChange}
              required={true}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Discount Amount</Label>
            <input
              name="discountAmount"
              type="text"
              className="form-control"
              placeholder="Enter discount amount here..."
              value={formData.discountAmount}
              onChange={handleChange}
              required={true}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Validity Date</Label>
            <input
              name="expiryDate"
              type="date"
              className="form-control"
              value={formData.expiryDate.slice(0, 10)}
              onChange={handleChange}
              min={new Date().toISOString().slice(0, 10)}
              required={true}
            />
          </FormGroup>
        </Col>
      </Row>
      <ButtonSection cancel_url={`/coupon/coupon_list`} />
    </form>
  );
};

export default CreateNewCouponForm;
